import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theme';

const FacetsButtonAndChipsContainer = styled('div')`
  max-width: 90rem;
  padding: 30px 12px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;

  ${theme.below.md} {
    padding: 16px 12px;
  }
`;

const FacetsButtonSkeleton = styled('div')`
  box-sizing: border-box;
  height: 44px;
  padding: 0 16px;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  background: linear-gradient(${theme.colors.white}, ${theme.colors.white})
      padding-box,
    linear-gradient(90deg, #ebe8e3 0%, #f6f4f1 40%, #ebe8e3 80%) border-box;
  background-size: auto, 200% 100%;
  animation: elevateFacetsBorderShimmer 1.15s ease-in-out infinite;

  @keyframes elevateFacetsBorderShimmer {
    0% {
      background-position: 0 0, 100% 0;
    }
    100% {
      background-position: 0 0, -100% 0;
    }
  }

  @keyframes elevateFacetsShimmer {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: -100% 0;
    }
  }

  .elevate-facets-sk {
    background: linear-gradient(90deg, #ebe8e3 0%, #f6f4f1 40%, #ebe8e3 80%);
    background-size: 200% 100%;
    animation: elevateFacetsShimmer 1.15s ease-in-out infinite;
    border-radius: 4px;
  }

  .elevate-facets-sk-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    border-radius: 2px;
  }

  .elevate-facets-sk-label {
    width: 7.5rem;
    height: 16px;
    border-radius: 2px;
  }
`;

export const ElevateFacetsFlyoutSkeleton = () => (
  <div
    id="filter-and-sort"
    className="filter-and-sort-wrapper elevate-facets-flyout-skeleton"
    aria-hidden="true"
  >
    <FacetsButtonAndChipsContainer>
      <FacetsButtonSkeleton>
        <div className="elevate-facets-sk elevate-facets-sk-icon" />
        <div className="elevate-facets-sk elevate-facets-sk-label" />
      </FacetsButtonSkeleton>
    </FacetsButtonAndChipsContainer>
  </div>
);
